export const BILLING_APPROVAL_CUTOVER_AT = "2026-08-31T22:00:00.000Z";

const BILLING_APPROVAL_CUTOVER_MS = Date.parse(BILLING_APPROVAL_CUTOVER_AT);

export interface BillingAttributionAssignment {
  task_status?: string;
  completed_at?: string | null;
  approved_at?: string | null;
}

function isBeforeCutover(value: string): boolean {
  const timestamp = Date.parse(value);
  return Number.isFinite(timestamp) && timestamp < BILLING_APPROVAL_CUTOVER_MS;
}

/**
 * Resolves the period date for assignment-based billing hours.
 *
 * Until 1 September 2026, completed and approved assignments use the legacy
 * completion date. From the cutover, only approved assignments count. New
 * approvals use approved_at, while approvals that predate the cutover retain
 * their historical completion-date attribution.
 */
export function resolveBillingAttributionDate(
  assignment: BillingAttributionAssignment,
  legacyFallback: string | null,
  asOf: Date,
): string | null {
  const status = assignment.task_status ?? "approved";
  const legacyDate = assignment.completed_at ?? legacyFallback;

  if (asOf.getTime() < BILLING_APPROVAL_CUTOVER_MS) {
    return status === "completed" || status === "approved" ? legacyDate : null;
  }

  if (status !== "approved") return null;

  if (assignment.approved_at) {
    return isBeforeCutover(assignment.approved_at)
      ? legacyDate
      : assignment.approved_at;
  }

  // Historical approved rows can lack approved_at. Preserve them only when
  // their legacy attribution clearly predates the cutover.
  return legacyDate && isBeforeCutover(legacyDate) ? legacyDate : null;
}
